import { CommandGetJourneys, JourneyOption } from "./commands/cmdGetJourneys";

export type { JourneyOption };

export class JourneyService {
  async getJourneys(): Promise<JourneyOption[]> {
    return new CommandGetJourneys().run();
  }
}
